



























/* eslint-disable @typescript-eslint/camelcase */

import {
  ClickToPlay,
  Controls,
  CurrentTime,
  EndTime,
  PlaybackControl,
  Player,
  Poster,
  Scrim,
  ScrubberControl,
  Ui,
  Video,
  VolumeControl
} from "@vime/vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    ClickToPlay,
    Controls,
    CurrentTime,
    EndTime,
    PlaybackControl,
    Player,
    Poster,
    Scrim,
    ScrubberControl,
    Ui,
    Video,
    VolumeControl
  }
})
export default class VimePlayer extends Vue {
  @Prop() private src?: string;
  @Prop() private mimetype?: string;
  @Prop() private poster?: string;
  @Prop() private aspectRatio?: string;

  private get player() {
    return this.$refs.player as HTMLVmPlayerElement;
  }

  private async onPlaybackReady() {
    if (await this.player.canMutedAutoplay()) {
      await this.play();
    }
  }

  private async play() {
    try {
      await this.player.play();
    } catch (error) {
      // error handling needed?
    }
  }
}
